import React, { memo, useCallback } from 'react';
import { FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';
import {
  PreviewLinkItem,
  TextInputPreview,
} from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const PreviewContactsList = memo(({ data, style }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();

  const renderItem = useCallback(
    ({ item: { type, logoName, url, raw }, index }) => {
      return type !== 'address' ? (
        <PreviewLinkItem logoName={logoName} title={raw} externalUrl={url} />
      ) : (
        <TextInputPreview
          style={styles.inputTextContainer}
          title={dictionary.shopContact.address}
          value={raw}
          editable={false}
        />
      );
    },
    []
  );

  return (
    <FlatList
      {...{ data }}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={[styles.listContentContainer, style]}
      ItemSeparatorComponent={() => <Space size={8} />}
      {...{ renderItem }}
    />
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  listContentContainer: {
    paddingHorizontal: 24,
    paddingBottom: 24,
  },
  inputTextContainer: {
    borderRadius: 10,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
}));
